import getAppState from 'app-state';
import React from 'react';
import ReactDOM from 'react-dom';
import Alert from './Alert'

export function init() {
    const alertSettings = getAppState('globalMaintenanceAlert');
    if (!alertSettings.enabled || alertSettings.text.length === 0) {
        return;
    }
    const wrapperDiv = document.createElement('div');
    document.body.prepend(wrapperDiv)
    ReactDOM.render(
        <Alert text={alertSettings.text} />, wrapperDiv
    );
}